import { useContext } from "react";
import { Context } from "../../Context";
import {
  Link,
  useNavigate,
} from "../../../../node_modules/react-router-dom/dist/index";
import { destroyCookie } from "nookies";

const TopBar = () => {
  const navigate = useNavigate();
  const [context, setContext] = useContext(Context);

  const logout = (e) => {
    console.log("first logoutlogoutlogout")
    try {
      e.preventDefault();
	  destroyCookie(null, 'NrisToken', {
		path: '/',
		domain: '.nris.com',
	  });
	  
	  destroyCookie(null, 'NrisUser', {
		path: '/',
		domain: '.nris.com',
	  });
      destroyCookie(null, "NrisUser", { path: "/" });
      destroyCookie(null, "NrisToken", { path: "/" });
      console.log("Token before:", localStorage.getItem("__nristoken"));
      console.log("User before:", localStorage.getItem("__nrisuser"));

      localStorage.removeItem("__nristoken");
      localStorage.removeItem("__nrisuser");
      console.log("Token after:", localStorage.getItem("__nristoken"));
      console.log("User after:", localStorage.getItem("__nrisuser"));

      localStorage.removeItem("__nristoken");
      localStorage.removeItem("__nrisuser");

      setContext((prevValue) => ({
        ...prevValue,
        user: null,
        userToken: null,
      }));
      console.log("logOut");

      navigate("/");
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className="topbar px-3 usa-bg">
        <div className="top-dot ">
          <div className="row align-items-center justify-content-center justify-content-md-between position-relative ">
            <div className="col-md-6 text-center text-md-start d-none d-md-inline-block">
              <div className="d-flex align-items-center justify-content-center justify-content-sm-start mb-2 mb-sm-0 position-relative">
                <img
                  className="me-2"
                  src="/assets/images/icons/mail.svg"
                  alt="NRIS mail"
                />
                <a href="mailto:info@nris.com">info@nris.com</a>
                <span className="mx-2">|</span>
                <img
                  className="me-2"
                  src="/assets/images/icons/phone.svg"
                  alt="NRIS mail"
                />{" "}
                844-435-7674
              </div>
            </div>
            <div
              className="col-md-6 text-end h6 mb-0 d-inline position-relative"
              style={{ zIndex: 1 }}
            >
              {context?.userToken && (
                <>
                  <div className="dropdown d-inline-block notification-menu">
                    <button
                      id="dropdownMenu2"
                      className="btn btn-warning rounded-0 fw-bold border-0 px-0 bg-transparent"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="false"
                      aria-expanded="false"
                    >
                      <i className="fi fi-rs-cowbell"></i>
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenu2"
                    >
                      <li className="dropdown-item">
                        <a href="#!" className="mb-0">
                          <span>Some one just</span> - posted a free ad in Autos
                          Classified in, Arkansas ,USA
                        </a>
                      </li>
                      <li className="dropdown-item">
                        <a href="#!" className="mb-0">
                          <span>Some one just</span> - posted a free ad in Baby
                          Sitting in, Arkansas ,USA
                        </a>
                      </li>
                      <li className="dropdown-item">
                        <a href="#!" className="mb-0">
                          <span>Some one just</span> - posted a free ad in
                          Education and Teaching in, Arkansas ,USA
                        </a>
                      </li>
                    </ul>
                  </div>
                  <span className="mx-2">|</span>
                </>
              )}
              <Link to="/advertise-with-us" className="me-0">
                Advertise
              </Link>
              {!context?.userToken ? (
                <>
                  <span className="mx-2">|</span>
                  <a
                    href="#!"
                    className="me-2"
                    data-bs-toggle="modal"
                    data-bs-target="#signupModal"
                  >
                    Register
                  </a>
                  <a
                    href="#!"
                    className="btn btn-warning rounded-0 fw-bold"
                    data-bs-toggle="modal"
                    data-bs-target="#loginModal"
                  >
                    Login
                  </a>
                </>
              ) : (
                <>
                  <Link
                    to="/profile"
                    className="btn btn-warning rounded-0 fw-bold ms-2"
                  >
                    <i className="fi fi-rs-user font11 linehight0 "></i>
                  </Link>
                  <a
                    href="#!"
                    className="btn btn-warning rounded-0 fw-bold ms-1"
                    id="nrisLogout"
                    onClick={logout}
                  >
                    Logout
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopBar;
